import { takeEvery, call, put } from "redux-saga/effects";
import actions from "./action";
import axios from "../../Helpers/axios";


const API_URL = process.env.REACT_APP_AUTH_SERVER_PRODUCTION;


function* createUserLoginResponse({ payload: { data } }) {
  try {
    const token = sessionStorage.getItem("biller_access");
    if (!token) throw new Error("No authentication token found");

    const response = yield call(
      axios.post,
      `${API_URL}/aicredentials`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 201 || response.status === 200) {
      yield put(actions.createUserLoginSuccess(response.data.message));
    } else {
      throw new Error(response.data.message || "Failed to create user login");
    }
  } catch (error) {
    console.error("Error in createUserLogin saga:", error);
    const errorMsg =
      error.response?.data?.message || error.message || "Network error";
    yield put(actions.createUserLoginFailed(errorMsg));
  }
}

function* getAllAICredentialDataSaga() {
  try {
    const token = sessionStorage.getItem("biller_access");
    if (!token) throw new Error("No authentication token found");

    const response = yield call(axios.get, `${API_URL}/aicredentials/getall`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response.data.success) {
      yield put(actions.getAllAICredentialDataSuccess(response.data.data));
    } else {
      throw new Error("Failed to fetch AI credentials");
    }
  } catch (error) {
    const errorMsg = error.response?.data?.message || error.message || "Network error";
    yield put(actions.getAllAICredentialDataFailed(errorMsg));
  }
}

function* updateAiDetailsSaga({ payload: { id, data } }) {
  try {
    const token = sessionStorage.getItem("biller_access");
    if (!token) throw new Error("No authentication token found");

    const response = yield call(
      axios.put,
      `${API_URL}/aicredentials/update/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200 || response.status === 201) {
      yield put(actions.updateAiDetailsSuccess(response.data.message));
      // refresh list after update
      yield put(actions.getAllAICredentialData());
    } else {
      throw new Error(response.data.message || "Failed to update AI details");
    }
  } catch (error) {
    const errorMsg =
      error.response?.data?.message || error.message || "Network error";
    yield put(actions.updateAiDetailsFailed(errorMsg));
  }
}


export default function* userLoginSaga() {
  yield takeEvery(actions.CREATE_USER_LOGIN, createUserLoginResponse);
   yield takeEvery(actions.GET_AllAICREDENTIAL_DATA, getAllAICredentialDataSaga);
    yield takeEvery(actions.UPDATE_AI_DETAILS, updateAiDetailsSaga);
}
